import { useTranslation } from "react-i18next";
import { Flex, Box, Heading, useColorModeValue } from "@chakra-ui/react";
import NavigationBar from "src/components/NavigationBar";
import ScrollBox from "src/atoms/ScrollBox";
import { BodyText } from "src/atoms/typography";
import getAgeForBirthdate from "src/modules/avatar/lib/getAgeForBirthdate";
import CorrespondingAvatar from "src/modules/avatar/components/CorrespondingAvatar";

function AvatarPreview({ t, name, breed, birthDate, openEditor, avatar }) {
  const boxShadow = useColorModeValue(
    "0 2px 4px -1px rgba(0, 0, 0, 0.12), 0 1px 16px 0 rgba(0, 0, 0, 0.06), 0 4px 8px 0 rgba(0, 0, 0, 0.08)",
    "0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14)"
  );
  const bg = useColorModeValue("white", "rgba(255, 255, 255, 0.08)");
  let age = getAgeForBirthdate(birthDate, t);

  return (
    <Box
      mb="32px"
      p="24px"
      width="323px"
      onClick={openEditor}
      borderRadius="12px"
      boxShadow={boxShadow}
      bg={bg}
      cursor="pointer"
    >
      <Flex alignItems="center">
        <Box mr="23px">
          <CorrespondingAvatar width="64px" height="64px" avatar={avatar} />
        </Box>
        <Box>
          <Heading
            fontSize="16px"
            fontWeight="500"
            lineHeight="1.5"
            letterSpacing="0.2px"
            color="highEmphasis"
            mb="1px"
            maxWidth="187px"
            overflow="hidden"
            textOverflow="ellipsis"
            display="-webkit-box"
            wordBreak="break-all"
            sx={{
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              wordWrap: "break-word"
            }}
          >
            {name}
          </Heading>
          {breed || avatar.moreDataJson ? (
            <BodyText
              maxWidth="187px"
              whiteSpace="nowrap"
              overflow="hidden"
              textOverflow="ellipsis"
              color="mediumEmphasis"
            >
              {breed || avatar.moreDataJson.breed}
            </BodyText>
          ) : null}

          <Box>
            <BodyText
              color="mediumEmphasis"
              as="span"
              textTransform="capitalize"
            >
              {avatar.sex === "male" ? t("avatar.male") : t("avatar.female")}
            </BodyText>
            {age && (
              <BodyText color="mediumEmphasis" as="span">
                {" "}
                &#183; {age}
              </BodyText>
            )}
          </Box>
        </Box>
      </Flex>
    </Box>
  );
}

export default function AvatarList({ avatars, openEditor, onBack, onClose }) {
  const { t } = useTranslation();
  return (
    <>
      <NavigationBar
        headingKey="avatars"
        actionButton={{
          onClick: openEditor,
          labelKey: "avatar.openEditorButton"
        }}
        onBack={onBack}
        onClose={onClose}
      />
      <Box py="16px" height="calc(100% - 61px)">
        <ScrollBox height="100%">
          <Flex flexDirection="column" alignItems="center" pt="16px">
            {avatars.map((avatar) => (
              <AvatarPreview
                key={avatar.objectId}
                {...avatar}
                avatar={avatar}
                openEditor={() => openEditor(avatar.objectId)}
                t={t}
              />
            ))}
          </Flex>
        </ScrollBox>
      </Box>
    </>
  );
}
